module.exports = __webpack_public_path__ + "img/bmp.3f1c0048.svg";